/* PPE Fast theme — nav, reveal, product gallery & options */
(function () {
  "use strict";
  var qs = function (s, el) { return (el || document).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* Mobile nav */
  var header = qs(".header");
  var toggle = qs(".nav-toggle");
  if (toggle && header) {
    toggle.addEventListener("click", function () {
      var open = header.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* Reveal on scroll */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    qsa(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    qsa(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  /* Product gallery */
  var main = qs("#pd-main");
  if (main) {
    qsa("#pd-thumbs .thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        qsa("#pd-thumbs .thumb").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        main.src = t.dataset.src;
      });
    });
  }

  /* Size buttons -> sync to the variant <select> (single-option products) */
  var select = qs("#variant-select");
  qsa(".size-row").forEach(function (row) {
    qsa(".size", row).forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa(".size", row).forEach(function (x) { x.classList.remove("active"); });
        btn.classList.add("active");
        if (select) {
          var val = btn.getAttribute("data-value");
          qsa("option", select).forEach(function (opt) {
            if (opt.textContent.indexOf(val) === 0) { select.value = opt.value; }
          });
        }
      });
    });
  });
})();
